import { QRCodeSVG } from "qrcode.react";
import Card from "components/card";

const CheckInCode = ({ parent, checkinCode }) => (
  <div className="flex flex-col gap-2">
    <Card padding="sm">
      <p className="text-sm text-fg-muted">Parent</p>
      <p className="text-base font-medium">
        {parent.firstName} {parent.lastName}
      </p>
    </Card>

    <Card padding="lg" className="items-center text-fg">
      <QRCodeSVG value={checkinCode} size={240} bgColor="transparent" fgColor="currentColor" />
    </Card>
  </div>
);

export default CheckInCode;
